import React, { useEffect } from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { ByfunnFrapiTagPage } from '../../../types/frapi-types.js';

import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import Pagination from '../../components/commonComponents/Pagination.js';
import Footer from '../../components/commonComponents/Footer.js';
import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { trackTagPageView, withByfunnPulse } from '../../../pulse/index.js';
import { makeTagTitle } from '../../components/articles/helpers.js';
import TeaserSearchResult from '../../components/teasers/TeaserSearchResult.js';

export type TagPageProps = {
  data: ByfunnFrapiTagPage;
  options: OptionsFromRequest;
};

const TagPage: React.FC<TagPageProps> = ({ data, options }) => {
  const { siteVersion, currentUrl } = options;
  const { trackViewListing, registerViewElementTracking } = usePulseContext();

  useEffect(() => {
    trackTagPageView(trackViewListing, currentUrl, data.info.slug);

    registerViewElementTracking();
  }, [trackViewListing, currentUrl, data, registerViewElementTracking]);

  const isMobile = siteVersion === 'phone';

  const pageCount = Math.ceil(data.articles.hits.total / 36);
  const currentPage = options.page ? parseInt(options.page) : 1;

  return (
    <div className={`${siteVersion}-front`}>
      <Navigation fullWidth={!isMobile} />
      <div className="tag-page-container">
        <h1 className="tag-page-title">{makeTagTitle(data.info.title)}</h1>
        <div className="tag-articles-all-wrapper">
          <div className="tag-articles-all">
            {data.articles.items.map((t, i) => (
              <TeaserSearchResult
                {...t}
                key={t.id}
                index={i}
                size="small"
                mobile={isMobile}
                fullWidthTeaser={false}
                lazyLoad={false}
                colorPalette={undefined}
              />
            ))}
          </div>
        </div>
        <Pagination
          pageCount={pageCount}
          currentPage={currentPage}
          pageId={data.info.slug}
          location="tag"
        />
      </div>

      <Footer isMobile={isMobile} />
    </div>
  );
};

const TagPageWithPulse = withByfunnPulse(TagPage);

export { TagPageWithPulse as TagPage };
